export const GET_OPTIONS = 'GET_OPTIONS'
export const SET_CURRENT = 'SET_CURRENT'
export const OPTIONS_ERROR = 'OPTIONS_ERROR'
export const GET_TOTAL = 'GET_TOTAL'
export const CLEAR_CONTACT = 'CLEAR_CONTACT'
export const SET_CONTACT = 'SET_CONTACT'
export const EMAIL_SUCCESS = 'EMAIL_SUCCESS'
export const EMAIL_ERROR = 'EMAIL_ERROR'
export const SET_LOADING = 'SET_LOADING'